export function userDisplayName(row) {
  if (!row) return ''
  return row.athleteName || row.fullName || row.nickname || row.nickName || row.username || row.name || ''
}

export function formatUserId(row) {
  if (!row || row.userId === undefined || row.userId === null || row.userId === '') return '-'
  const name = userDisplayName(row)
  return name ? `${row.userId} (${name})` : String(row.userId)
}
